import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ParceiroNegocio } from 'app/interfaces/parceiro-negocio';
import { tap, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ParceiroHttpService } from 'app/main/parceiro/parceiro-http.service';

@Injectable()
export class UsuarioAddResolver implements Resolve<ParceiroNegocio> {
  constructor(
    private _router: Router,
    private _parceiroHttpService: ParceiroHttpService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ParceiroNegocio | Observable<ParceiroNegocio> | Promise<ParceiroNegocio> {
    const navigation = this._router.getCurrentNavigation();
    if (navigation && navigation.extras.state?.parceiroNegocioId) {
      return this._parceiroHttpService.getParceiroInformacoesUsuarioById(navigation.extras.state?.parceiroNegocioId).pipe(
        tap(result => {
          if (result.usuarioId) {
            this._router.navigate(['/usuario/details', result.usuarioId], { replaceUrl: true });
          }
        }),
        catchError(err => {
          return undefined;
        }));
    } else {
      return undefined;
    }
  }
}